import React, { Component } from 'react';

export default class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <span> © 2018 AlphaSmithy </span>
        <a href="mailto:info@alphasmithy.com">Contact Us</a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js